const apiErrorMappingsV2 = {
  vehicle_id: {
    'ORDER.CUSTOMER.CONTRACT_VEHICLE.DUPLICATE_VEHICLE': 'Kendaraan telah digunakan di dalam kontrak kendaraan.',
    'ORDER.CUSTOMER.CONTRACT_VEHICLE.VEHICLE_NOT_FOUND': 'Kendaraan telah terhapus dari sistem.',
  },
  driver_user_id: {
    'ORDER.CUSTOMER.CONTRACT_VEHICLE.DUPLICATE_DRIVER': 'Pengemudi utama telah digunakan di dalam kontrak kendaraan.'
  },
  driver_user_2_id: {
    'ORDER.CUSTOMER.CONTRACT_VEHICLE.DUPLICATE_DRIVER_2': 'Pengemudi tambahan telah digunakan di dalam kontrak kendaraan.'
  },
}

export default apiErrorMappingsV2
